import axios from 'axios';
import { from, of } from 'rxjs';
import {
  tap,
  map,
  pluck,
  catchError,
  filter,
} from 'rxjs/operators';
import store, { REQUIRE_LOGIN } from '../store';

const DEFAULT_HANDLER = {
  next: null,
  error: null,
  complete: null,
};

const http = (options, handler = DEFAULT_HANDLER) => from(
  axios({
    ...options,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      username: localStorage.getItem('username'),
    },
  }),
)
  .pipe(
    map(({ data: { payload } }) => ({
      payload,
      err: null,
    })),
    catchError(({ response }) => of({
      payload: null,
      err: response,
    })),
  )
  .pipe(
    tap(({ err }) => {
      if (err && err.status === 419) {
        store.dispatch(REQUIRE_LOGIN, err.data.msg);
      }
    }),
    tap(({ payload, err }) => {
      if (typeof handler === 'function') {
        // when handler is type of function, handle as complete()
        handler();
        return;
      }
      if (handler.next && !err) {
        handler.next(payload);
      }
      if (err) {
        if (handler.error) {
          handler.error(err);
        }
      }
      if (handler.complete) {
        handler.complete();
      }
    }),
    filter(({ err }) => !err),
    pluck('payload'),
  );

export default http;
